module.exports = __webpack_public_path__ + "static/media/06-make.624b2b2a.png";